import styled from "styled-components";
import StoreButtonBase from "../../StoreButtonBase/StoreButtonBase";
import { StyledGooglePlayButtonProps } from "../GooglePlayButton.types";

const StyledGooglePlayButton = styled(
	StoreButtonBase
)<StyledGooglePlayButtonProps>`
	:disabled {
		.GooglePlayButton__icon {
			opacity: 0.4;
		}
	}
`;

export default StyledGooglePlayButton;
